import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

import { User } from '@app/admin/models/user';
import { Router } from '@angular/router';
import { AddUserComponent } from './add-user/add-user.component';
import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { UserState } from '@app/core/store/reducers/user';
import { getResourceState, getFilteredUsers, getUserFilter } from '@dwo/selectors';
import { LoadAllUsers, FilterUsers } from '@dwo/actions';
import { ResourceStatus, ResourceType } from '@dwo/enums';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  standalone: false,
})
export class UsersComponent implements OnInit, OnDestroy {
  displayColumns: string[] = ['username', 'fullName', 'sapId', 'actions'];
  dataSource: MatTableDataSource<User> = new MatTableDataSource();
  filter = '';
  loading: boolean;
  private readonly destroy$ = new Subject<void>();

  @ViewChild(MatSort, { static: false }) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  constructor(
    private store: Store<UserState>,
    private router: Router,
    private dialog: MatDialog,
  ) {
    this.store.dispatch(new LoadAllUsers());
  }

  ngOnInit() {
    this.store.dispatch(new LoadAllUsers());
    this.store
      .select(getFilteredUsers)
      .pipe(takeUntil(this.destroy$))
      .subscribe((users) => {
        this.dataSource.data = users;
      });
    this.store
      .select(getUserFilter)
      .pipe(takeUntil(this.destroy$))
      .subscribe((filter) => {
        this.filter = filter;
      });
    this.store
      .select(getResourceState, ResourceType.LoadAllUsers)
      .pipe(takeUntil(this.destroy$))
      .subscribe((state) => {
        this.loading = state.status === ResourceStatus.InProgress;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onRefresh(): void {
    this.store.dispatch(new LoadAllUsers());
  }

  onFilter(filter: string) {
    this.store.dispatch(new FilterUsers(filter));
  }

  onAdd() {
    this.dialog
      .open(AddUserComponent)
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.store.dispatch(new FilterUsers(''));
        }
      });
  }
}
